// addGroupBy — VQE-Edit edit-action: append a GROUP BY entry via SR-Edit's
// `add-group-by` op. SR-Edit synthesizes the `GROUP BY` keyword when the list
// is empty and inserts it at the right clause-tail offset (after FROM/WHERE,
// before HAVING/ORDER BY/LIMIT) — this module just builds the StructuralEdit
// and delegates to `commitEdit`.
//
// PRD: Ralph/VisualQueryEditorEdit/PRD.md § Slice: Edit — add/remove GROUP BY.

import { commitEdit, type CommitEditCtx } from '../commitEdit';

/**
 * Append a GROUP BY entry built from a column/expression text. SR-Edit's
 * `add-group-by` op does not currently support a midlist `afterIndex`; the new
 * entry is always appended to the tail of the list (or synthesizes the clause
 * if absent). Use `addGroupByExpression` for non-Column inputs.
 */
export async function addGroupBy(columnText: string, ctx: CommitEditCtx): Promise<void> {
  const text = columnText.trim();
  if (text.length === 0) {
    throw new Error('addGroupBy: columnText must not be empty');
  }
  await commitEdit({ op: 'add-group-by', columnText: text }, ctx);
}

/**
 * Alias for `addGroupBy` kept as a parallel entry-point for callers that have
 * a fully-formatted expression already (e.g. from a popover that built the
 * text via `formatColumnRef` or from the SELECT-list aggregate-awareness
 * one-click "auto-add to GROUP BY" hint).
 */
export async function addGroupByExpression(text: string, ctx: CommitEditCtx): Promise<void> {
  await addGroupBy(text, ctx);
}
